// extracted by mini-css-extract-plugin
export default {"heading":"header_heading__7axK4","container":"header_container__E9Jgi","hidden":"header_hidden__cpSN5","closeButton":"header_closeButton__hH5lD"};